/**
 * Does a shallow comparison of two objects.  If one is empty and the other isn't, it returns false regardless of onlyCheckCommonFields.
 *
 * @param a an object to compare
 * @param b another object to compare
 * @param onlyCheckCommonFields If onlyCheckCommonFields is true, we ignore fields in a that aren't in b or vice-versa.
 * @returns true if the objects are equal, false otherwise
 */
// eslint-disable-next-line complexity
export function shallowEquals(
  // eslint-disable-next-line @typescript-eslint/ban-types
  a: Object,
  // eslint-disable-next-line @typescript-eslint/ban-types
  b: Object,
  onlyCheckCommonFields = false
) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (!onlyCheckCommonFields) {
    if (aKeys.length !== bKeys.length) {
      return false;
    }
  }
  if (
    aKeys.length !== bKeys.length &&
    (aKeys.length == 0 || bKeys.length == 0)
  ) {
    return false; // one is just empty and the other not.
  }
  for (const key of aKeys) {
    if (bKeys.includes(key)) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      if ((a as any)[key] !== (b as any)[key]) {
        return false;
      }
    }
  }
  return true;
}
